import './style.css';
import { useLocation } from 'react-router-dom';
import { Trans } from '@lingui/react/macro';

function NotFound() {
  const location = useLocation();
  return(
    <div className="view not-found">
      <h2>404</h2>
      <p>
        <Trans>The route <code>{location.pathname}</code> was not found.</Trans>
      </p>
    </div>
  );
}

export default NotFound;
